const BlazeError = require('./blaze');
const { VALIDATION_ERROR_STATUS } = require('../constants');

class BlazeValidationError extends BlazeError {
  constructor(message, { errors = [], invalidProperties = [], ...errorProperties } = {}) {
    super(message, errorProperties);
    this.status = VALIDATION_ERROR_STATUS;
    this.errors = errors;
    this.invalidProperties = invalidProperties;
  }
}

module.exports = BlazeValidationError;
